// extracted by mini-css-extract-plugin
export default {"container":"ClassicForm_container__Bx4tn"};